import styled from 'styled-components';
import { paddings } from '~/styled/GlobalStyles';

interface Props {
  $smallPadding?: boolean;
}
export const MenuLabel = styled.label<Props>`
  text-transform: initial;
  font-weight: 400;
  padding: ${() => paddings.defaultPadding};
  padding-left: ${({ $smallPadding }) =>
    $smallPadding ? paddings.defaultPadding : paddings.hugePadding};
`;

export { MenuItem, Shield, ShieldCenter, ShieldEdge, IconWrapper } from '../MobileMenuItem/styled';
